import { PriceItem } from './PriceItem';

const mergePriceItems = (services) => {
  return services?.map((s) => PriceItem.mergeSavedService(s));
};

export default mergePriceItems;
